import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalService } from 'src/app/services/modal/modal.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from 'src/app/services/login/login.service';
import { DelegationService } from 'src/app/services/delegation/delegation.service';
import { CabinetService } from 'src/app/services/office/cabinet.service';
import { Delegation } from 'src/app/utils/interfaces/new/delegation.interface';
import { Destinataire } from 'src/app/utils/interfaces/new/destinataire.interface';
import { AuthService } from 'src/app/services/auth/auth.service';
import { LocalAuth } from 'src/app/utils/interfaces/new/localauth.interface';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { EtatDeploiementEnum } from 'src/app/utils/interfaces/new/cabinet.interface';

@Component({
  selector: 'app-select-docteur',
  templateUrl: './select-docteur.component.html',
  styleUrls: ['./select-docteur.component.scss']
})
export class SelectDocteurComponent implements OnInit {

  public docteurForm: FormGroup;
  public listDocteur: DocteurDelegation[] = [];
  public login = false;
  public idCabinet: string;
  public search = '';

  constructor(
    private formBuilder: FormBuilder,
    private modalService: ModalService,
    private viewContainerRef: ViewContainerRef,
    private delegationService: DelegationService,
    private cabinetService: CabinetService,
    private authService: AuthService,
    private loginService: LoginService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private _strUtilsSrv: StringUtilsService
  ) { }

  async ngOnInit(): Promise<void> {
    this.login = true;
    this.docteurForm = this.formBuilder.group({
      docteur: ['', [Validators.required]]
    });
    this.idCabinet = this.activatedRoute.snapshot.paramMap.get('id');
    try {
      const delegations = await this.delegationService.findReceivedDelegations();
      const profils = await this.cabinetService.findCurrentCabinetProfils();
      for (const delegation of delegations) {
        const profil = profils.find((profil) => profil.id == delegation.idDelegant);
        if (profil) {
          this.listDocteur.push({
            delegation,
            qualite: profil.qualite,
            nom: profil.nom.toLocaleUpperCase(),
            prenom: this._strUtilsSrv.uppercaseFirstCharString(profil.prenom),
            profil
          })
        }
      }
      this.login = false;
    } catch (e) {
      console.error(e);
    }
  }

  public async onSubmit(): Promise<void> {
    this.docteurForm.markAllAsTouched();
    if (this.docteurForm.valid) {
      const loadingModal = this.modalService.openLoading(this.viewContainerRef);
      try {
        const profil = await this.authService.selectDelegation(this.docteurForm.controls.docteur.value.delegation.id);

        this.loginService.saveCurrentDelegataireProfil(this.loginService.getCurrentProfil());
        this.loginService.saveCurrentDelegataireUser(this.loginService.getCurrentUser());
        this.loginService.saveCurrentProfil(profil);
        this.loginService.saveCurrentUser(profil.utilisateur);

        if (profil) {
          if (!profil.cabinet) {
            this.router.navigateByUrl(`/stop-page/generic`);
          } else if (profil.cabinet.disabled) {
            this.router.navigateByUrl(`/stop-page/disabled`);
          } else if (profil.cabinet.etatDeploiement !== EtatDeploiementEnum.Deploye) {
            this.router.navigateByUrl('/stop-page/not-deployed');
          } else {
            this.router.navigateByUrl('/user/home');
          }
        } else {
          this.router.navigateByUrl('/stop-page/generic');
        }

      } catch (e) {
        throw e;
      } finally {
        this.modalService.close(loadingModal);
      }
    }
  }
}

interface DocteurDelegation {
  nom: string;
  prenom: string;
  qualite: string;
  delegation: Delegation;
  profil: Destinataire;
}
